import {Component, OnInit} from '@angular/core';
import {HealthAPIService} from '../../services/health-api.service';
import {take} from 'rxjs';

@Component({
  selector: 'app-health',
  imports: [],
  templateUrl: './health.component.html',
  standalone: true,
  styleUrl: './health.component.css'
})
export class HealthComponent implements OnInit {
  public apiCheck = '';
  public apiCheck2 = '';
  constructor(private healthAPIService: HealthAPIService, ) { }

  ngOnInit(): void {
    this.healthAPIService
      .getAPIHealthCheck()
      .pipe(take(1))
      .subscribe({
        next: (value) => {
          this.apiCheck = value;
        },
        error: (err: any) => {
          this.apiCheck = 'The API Check Failed.';
        }
      });
  }
}
